import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { LoadingStyled } from 'components';
import sraApi from 'helpers/apis/sra';
import { enqueueAlertSnackbar } from '@trustsecurenow/components-library';
import { NameAndLocation, Network, Email, MediaAndDevices, System, AdditionalInformation, EmrAndEhr } from './tabs';
import { TabsHeader, TabsFixed, TabButton } from '../../../tabs/ComponentTypes';

const availableTabs = [
  {
    name: 'name_and_location',
    label: 'Name and Location',
    Component: NameAndLocation
  },
  {
    name: 'network',
    label: 'Network',
    Component: Network
  },
  {
    name: 'emr_ehr',
    label: 'EMR/EHR',
    Component: EmrAndEhr
  },
  {
    name: 'email',
    label: 'Email',
    Component: Email
  },
  {
    name: 'media_and_devices',
    label: 'Media and Devices',
    Component: MediaAndDevices
  },
  {
    name: 'system',
    label: 'System',
    Component: System
  },
  {
    name: 'additional_info',
    label: 'Additional Information',
    Component: AdditionalInformation
  }
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

const OrganizationProfile = ({ clientId, isHSN, handleClose, state, setState }) => {
  const [currentTab, setCurrentTab] = useState(availableTabs[0].name);
  const [loading, setLoading] = useState(false);
  // removing the emr/ehr tab, if the client is not HSN
  const filteredAvailableTabs = isHSN ? availableTabs : availableTabs.filter(tab => tab.name !== 'emr_ehr');

  // Get organization profile data
  useEffect(() => {
    if (!state) {
      setLoading(true);
      sraApi
        .getClientOrganizationProfile(clientId)
        .then(res => {
          setState(res.data);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [state, clientId]);

  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue);
  };

  // Save organization profile data
  const onSave = (action, currentTabIndex, newState) => {
    setLoading(true);

    const stateData = {
      ...state,
      ...(newState && { ...newState })
    };

    sraApi
      .setClientOrganizationProfile(clientId, stateData)
      .then(() => {
        enqueueAlertSnackbar('Saved successfully.', { props: { severity: 'success' } });
        if (action === 'next') {
          handleChangeTab({}, filteredAvailableTabs[currentTabIndex + 1].name);
        }
        if (action === 'close') {
          handleClose();
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (loading) return <LoadingStyled />;

  return (
    <Box mt={3}>
      <TabsFixed>
        <TabsHeader variant="scrollable" scrollButtons="desktop" value={currentTab} onChange={handleChangeTab}>
          {filteredAvailableTabs.map(tab => {
            return <TabButton value={tab.name} label={tab.label} />;
          })}
        </TabsHeader>
      </TabsFixed>
      {filteredAvailableTabs.map((tab, index) => {
        const { name, Component } = tab;
        return (
          <TabPanel value={currentTab} index={name}>
            <Component
              state={state || {}}
              setState={setState}
              onSave={onSave}
              clientId={clientId}
              isHSN={isHSN}
              handleClose={handleClose}
              currentTabIndex={index}
            />
          </TabPanel>
        );
      })}
    </Box>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  index: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any.isRequired
};

OrganizationProfile.propTypes = {
  clientId: PropTypes.string.isRequired,
  isHSN: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  state: PropTypes.oneOfType([null, PropTypes.object]).isRequired,
  setState: PropTypes.func.isRequired
};
export default OrganizationProfile;
